import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { UmssIconComponent } from "../icon/icon.component";

@Component({
  selector: "umss-toggle-icon-button",
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: "./toggle-icon-button.component.html",
  styleUrls: ["./toggle-icon-button.component.scss"],
})
export class UmssToggleIconButtonComponent {
  @HostBinding("style.display") display = "contents";

  constructor() { }

  /** Content props */
  @Input() iconName?: string; // Phosphor icon name (e.g., 'phosphorHeart', 'phosphorGear')
  @Input() ariaLabel?: string; // Accessibility label

  /** Variant props - Well-typed and comprehensive */
  @Input() variant: 'outlined' | 'ghost' = 'outlined'; // Visual style variant
  @Input() size: 'Mini' | 'Small' | 'Regular' | 'Large' = 'Regular'; // Size variant
  @Input() position: 'Left' | 'Middle' | 'Right' | 'Single' = 'Single'; // Button group position

  /** State props - Simple and clear */
  @Input() pressed: boolean = false; // Toggle state
  @Input() disabled: boolean = false; // Disabled state

  /** Events - Proper event handling */
  @Output() onToggle = new EventEmitter<boolean>(); // Emits the new pressed state
  @Output() onClick = new EventEmitter<MouseEvent>(); // Emits click event

  onButtonClick(event: MouseEvent) {
    if (!this.disabled) {
      this.pressed = !this.pressed;
      this.onToggle.emit(this.pressed);
      this.onClick.emit(event);
    }
  }

  /** Computed properties for accessibility */
  get computedAriaLabel(): string {
    if (this.ariaLabel) {
      return `${this.ariaLabel} ${this.pressed ? 'pressed' : 'not pressed'}`;
    }
    return `Toggle icon button ${this.pressed ? 'pressed' : 'not pressed'}`;
  }

  get computedAriaPressed(): string {
    return this.pressed.toString();
  }
  
  get iconSize(): string {
    switch (this.size) {
      case 'Mini': return '12px';
      case 'Small': return '14px';
      case 'Regular': return '16px';
      case 'Large': return '20px';
      default: return '16px';
    }
  }
  
  get defaultIconName(): string {
    return this.iconName || 'phosphorGear'; // Default fallback icon
  }
}
